import { render, staticRenderFns } from "./VacancyStat.vue?vue&type=template&id=faa7ecc2&"
import script from "./VacancyStat.vue?vue&type=script&lang=js&"
export * from "./VacancyStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports